define('shared/initializer/form/newHouseAdapters/CreditCardPayment',[
    '$',
    'shared/lib/ctor',
    'shared/initializer/form/constants',
    './Payment',
    '../adapters/mixins/fields/CreditCardName',
    '../adapters/mixins/fields/CCV',
    '../adapters/mixins/Returnable',
    './mixins/CreditCardPayable',
    './mixins/ExistingMethodPayable',
    './mixins/NoCardPayable',
    './mixins/upsell/Payment'
],
function (
    $,
    ctor,
    constants,
    Payment,
    CreditCardNameField,
    CCVField,
    Returnable,
    CreditCardPayable,
    ExistingMethodPayable,
    NoCardPayable,
    UpsellPayment
) {
    'use strict';

    var Ctor = ctor(function() {
        var me = this;
        me.base.apply(me, arguments);
        me.prefillable = {
            fields: {
                firstName: constants.FIELD.CREDIT_CARD_FIRSTNAME,
                lastName: constants.FIELD.CREDIT_CARD_LASTNAME,
                fullName: constants.FIELD.CREDIT_CARD_FULLNAME
            }
        };
        me.mixin(
            CreditCardPayable,
            ExistingMethodPayable,
            NoCardPayable,
            UpsellPayment,
            Returnable,
            CreditCardNameField,
            CCVField
        );
    }).inherit(Payment);

    return Ctor;
});

